export default __webpack_public_path__ + "static/media/upload.e49371b9.svg";